import {Component, OnDestroy, OnInit} from '@angular/core';
import {AbstractBffApi, Service} from '../../../../models/sharedinterface';
import {ApiFactoryService} from '../../../../shared/services/api-factory.service';
import {interval, Observable} from 'rxjs';
import {takeWhile} from 'rxjs/operators';

@Component({
  selector: 'app-service-status',
  templateUrl: './service-status.component.html',
  styleUrls: ['./service-status.component.scss']
})

export class ServiceStatusComponent implements OnInit, OnDestroy {

  services: Service[];
  blockedServices: Service[];

  watcher: Observable<number>;
  watcherFrequency = 180; // in seconds
  isRefreshing = false;
  isActive = false;
  isReady = false;

  bffapi: AbstractBffApi;

  constructor(private apifactory: ApiFactoryService) {
    this.bffapi = this.apifactory.createBffApi();
  }

  ngOnInit(): void {
    this.isRefreshing = this.isActive = true;
    this.fetchServices();

    // Watches the services status every 5 sec
    this.watcher = interval(this.watcherFrequency * 1000).pipe(takeWhile(_ => this.isActive));
    this.services = [];
    this.blockedServices = [];

    this.watcher.subscribe(() => {
      // if already running we cancel any new one
      if (this.isRefreshing) {
        return;
      }
      this.isRefreshing = true;
      this.fetchServices();
    });
  }

  ngOnDestroy(): void {
    this.isActive = this.isRefreshing = false;
  }

  private fetchServices() {
    // Fetches services status data
    const queryServices = this.bffapi.getServices();
    queryServices.subscribe((responseServices) => {
      this.services = responseServices.results;
      // Fetches blocked services status data
      const queryBlockedServices = this.bffapi.getBlockedServices();
      queryBlockedServices.subscribe((responseBlockedServices) => {
        this.blockedServices = responseBlockedServices.results;
        this.isRefreshing = false;
        this.isReady = true;
      });
    });
  }

  getStatusClass(service: Service) {
    switch (service.status) {
      case 'up':
        return 'fa-arrow-alt-circle-up text-success';
      case 'down':
        return 'fa-exclamation-circle text-danger';
      default:
        return 'fa-question-circle text-warning';
    }
  }

  getBlockedServiceStatusClass(service: Service) {
    switch (service.status) {
      case 'up':
        return 'fa-unlock text-danger';
      case 'down':
        return 'fa-lock text-success';
      default:
        return 'fa-question-circle text-warning';
    }
  }
}
